import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id, e) => {
    if (e) e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Über mich', id: 'ueber-uns' },
    { label: 'Leistungen', id: 'leistungen' },
    { label: 'Arbeitsweise', id: 'arbeitsweise' },
    { label: 'Kontakt', id: 'kontakt' }
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
        }`}
      >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <button
            onClick={() => scrollToSection('hero')}
            className="flex items-center gap-3 hover:opacity-80 transition-opacity"
          >
            <img src="/logo.png" alt="Smart Post Solution" className="h-16" />
            <span className="text-lg font-semibold text-slate-800 hidden sm:inline">Smart Post Solution</span>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => scrollToSection(item.id, e)}
                className="text-slate-600 hover:text-slate-900 transition-colors font-medium"
              >
                {item.label}
              </a>
            ))}
            <a href="tel:+497235975942" className="flex items-center gap-1.5 text-slate-600 hover:text-slate-900 transition-colors text-sm">
              <Phone size={14} />
              07235 - 9759-427
            </a>
            <Button
              onClick={() => scrollToSection('kontakt')}
              className="text-slate-900 font-semibold"
              style={{ backgroundColor: '#FFA266' }}
            >
              Kontakt aufnehmen
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-slate-800"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden pb-6 space-y-4">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => scrollToSection(item.id, e)}
                className="block w-full text-left text-slate-600 hover:text-slate-900 transition-colors font-medium py-2"
              >
                {item.label}
              </a>
            ))}
            <Button
              onClick={() => scrollToSection('kontakt')}
              className="w-full text-slate-900 font-semibold"
              style={{ backgroundColor: '#FFA266' }}
            >
              Kontakt aufnehmen
            </Button>
          </nav>
        )}
      </div>
    </header>
    </>
  );
};

export default Header;